const Main = () => import("@/views/main.vue");
// tab切换
// const UserMain = () => import("@/views/user/userMain.vue");
// 列表
const NewShowdata = () => import("@/views/Newshowdata");

export default [
    {
        path: "/newshowdata",
        name: "newshowdata",
        component: Main,
        meta: {
            name: "新版数据屏设置",
            unfold: false, //是否可以被展开
            iconType: "edit"
        },
        redirect: {
            name: "newshowdataPanel"
        },
        children: [
            {
                path: "",
                name: "newshowdataPanel",
                component: NewShowdata,
                meta: {
                    name: "新版数据屏设置",
                    title: "数据设置",
                    role:{}
                }
            }
        ]
    }
];